import { render, staticRenderFns } from "./objStorage.vue?vue&type=template&id=4fe43813&scoped=true"
import script from "./objStorage.vue?vue&type=script&lang=js"
export * from "./objStorage.vue?vue&type=script&lang=js"
import style0 from "./objStorage.vue?vue&type=style&index=0&id=4fe43813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe43813",
  null
  
)

export default component.exports